import { getApiUrl } from '../../api'

// Кеширование базового URL для синхронного доступа
let baseApiUrl: string = window.location.origin
getApiUrl().then(url => {
  baseApiUrl = url
  setFavicon()
  setDocumentTitle()
  setStyles()
})

// Получить текущую тему из localStorage
export const getCurrentTheme = (): string => localStorage.getItem('data-app-theme') || ''

// Устанавливает и возвращает document.title в зависимости от hostname
export const getProjectName = (): string => {
  const [first, second] = window.location.hostname.split('.')
  const domain = second || first
  const sub = second ? first : null
  let title = 'CRM'
  switch (domain) {
    case 'ritzipcrm': title = 'RitzipCRM'; break
    case 'adwanto':    title = 'Adwanto';    break
    case 'purple':     title = 'Flowerbloom'; break
    case 'mewbas':     title = sub === 'crm-admin' ? 'OxCRM' : 'DocaCRM'; break
    case 'orange':     title = 'Poedimdostavka'; break
    case 'dark_green': title = 'Lease2own';     break
    case 'green':      title = '5harmonies';         break
    case '5h':         title = 'Личный кабинет | 5h'; break
  }
  document.title = title
  return title
}

// Alias для прямой установки заголовка
export const setDocumentTitle = getProjectName

// Устанавливает favicon по синхронному URL
export const setFavicon = (): void => {
  const favicon = document.getElementById('favicon') as HTMLLinkElement | null
  if (!favicon) return
  favicon.href = getFaviconUrl()
}

//синхронная установка fav, title, bgImage
export const setStyles = (theme?: string): void => {
  let appliedTheme = theme
  if (theme) {
    localStorage.setItem('data-app-theme', theme)
  } else {
    appliedTheme = getCurrentTheme()
  }
  const layout = appliedTheme === 'dark' ? 'light-sidebar' : 'dark-sidebar'
  if (appliedTheme) {
    document.documentElement.setAttribute('data-app-theme', appliedTheme)
  } else {
    document.documentElement.removeAttribute('data-app-theme')
  }
  setTimeout(() => document.body.setAttribute('data-kt-app-layout', layout), 0)

  let hostname = baseApiUrl
  if (hostname.includes('://')) {
    hostname = hostname.split('://')[1]
  }

  const urlParts = hostname.split('.')
  const currentSubdomain = urlParts.length === 3 ? urlParts[0] : null

  const bgUrl = `${baseApiUrl}/uploads/${currentSubdomain}/auth/preview`
  const faviconUrl = `${baseApiUrl}/uploads/${currentSubdomain}/basic/fav`

  const layoutElement = document.querySelector('.auth-layout') as HTMLElement | null
  if (layoutElement) {
    layoutElement.style.backgroundImage = `url(${bgUrl})`
  }

  const favicon = document.getElementById('favicon') as HTMLLinkElement | null
  if (favicon) {
    favicon.href = faviconUrl
  }

  setDocumentTitle()
}

// Получает URL фонового изображения для экрана авторизации
export const getAuthBackgroundUrl =  (): string => getDynamicUrlSync('/auth/preview')

// Получает URL логотипа для текущей темы
export const getLogoUrl = (): string => {
    const theme =
        document.documentElement.getAttribute('data-theme') === 'dark'
            ? 'dark'
            : 'light'

    return getDynamicUrlSync(`/basic/${theme}/logo`)
}

// Получает URL favicon для текущей темы
export const getFaviconUrl = (): string => getDynamicUrlSync('/basic/fav')

// Синхронное построение динамического URL
export function getDynamicUrlSync(path: string): string {
  const apiUrl =  baseApiUrl
  let hostname = apiUrl
  if (hostname.includes('://')) {
    hostname = hostname.split('://')[1]
  }
  const url = hostname.split('.')
  const currentSubdomain = url.length === 3 ? url[0] : null
  return `${apiUrl}/uploads/${currentSubdomain + path}`
}
